/**
 * @generated SignedSource<<e06c5217128bde45a816440c22accf51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleSelectField_Platform$data = {
  readonly __typename: "JiraSingleSelectField";
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly fieldOption: {
    readonly color: {
      readonly colorKey: string | null;
    } | null;
    readonly value: string | null;
  } | null;
  readonly fieldOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: {
          readonly colorKey: string | null;
        } | null;
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "JiraSingleSelectField_Platform";
};
export type JiraSingleSelectField_Platform$key = {
  readonly " $data"?: JiraSingleSelectField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraSingleSelectField_Platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "concreteType": "JiraColor",
    "kind": "LinkedField",
    "name": "color",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorKey"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraSingleSelectField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "fieldOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraSingleSelectField"
};
})();

(node as any).hash = "ef651f5bb749d7c5b877b85cce4f4c5b";

export default node;
